const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-year",
        label: "연도",
        value: "year",
        query: { y: "year" },
        options: {
          default: new Date().getFullYear(),
        },
      },
      {
        component: "search-check-group",
        label: "",
        value: "fieldCompany",
        query: { ck_l2: "checkList" },
        options: {
          list: [
            { text: "전체", value: "전체" },
            { text: "해빙기", value: "해빙기" },
            { text: "우수기", value: "우수기" },
            { text: "동절기", value: "동절기" },
            { text: "기타", value: "기타" },
          ],
          selectMaxCount: 1,
          default: ["전체"],
        },
      },
      { component: "empty-space" },
      {
        component: "search-start-end",
        label: "작성일",
        value: "date",
        query: { ss: "startDate", ee: "endDate" },
        options: {
          default: { sd: "", ed: "" },
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["점검기간", "소관부서", "작성일"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  점검연도
    if (search.year) {
      conditions.push({ key: "body.점검연도", operator: "LIKE", value: `${search.year}` });
    }
    //  점검구분
    if (search.fieldCompany && search.fieldCompany[0] !== "전체") {
      conditions.push({ key: "body.점검구분", operator: "LIKE", value: `%${search.fieldCompany[0]}%` });
    }

    //  작성일
    if (search.date) {
      conditions.push({ key: "created_at", operator: ">=", value: search.date.startDate });
      conditions.push({ key: "created_at", operator: "<", value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : "" });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      { name: "연도", key: "body.점검연도" },
      { name: "시설명", key: "body.점검대상시설명[%].field_name", style: { maxWidth: "350px", whiteSpace: "normal", wordBreak: "break-all" } },
      { name: "구분", key: "body.점검구분" },
      { name: "점검기간", key: "body.점검기간" },
      { name: "소관부서", key: "body.점검대상시설명[%].meta", style: { maxWidth: "350px" } },
      { name: "팀명", key: "body.stdInfo.section" },
      { name: "작성자", key: "body.stdInfo.writer_name" },
      { name: "작성일", key: "created_at" },
    ];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0:
          return func.getContent(value).점검연도 || ""; // 연도
        case 1: {
          // 시설명
          const fields = func.getContent(value).점검대상시설명.map((item) => item.field_name);
          const result = fields.join(", ");
          return result.length > 20 ? `${result.substring(0, 20)}...` : result;
        }
        case 2:
          return func.getContent(value).점검구분 || ""; // 구분
        case 3: {
          // 점검기간
          const 점검기간 = func.getContent(value).점검기간;
          if (점검기간) {
            const start = new Date(점검기간.sDate).format("yyyy-MM-dd");
            const end = new Date(점검기간.eDate).format("yyyy-MM-dd");
            return `${start} ~ ${end}`;
          }
          return "";
        }
        case 4: {
          // 소관부서
          const body = func.getContent(value);
          if (body.점검대상시설명 && body.점검대상시설명.length > 0) {
            const 소관부서 = body.점검대상시설명.map((item) => {
              const meta = item.meta ? JSON.parse(item.meta) : {};
              return meta.소관부서;
            });
            return [...new Set(소관부서)].filter(Boolean).join(", ");
          }
          return "";
        }
        case 5:
          return func.getContent(value).stdInfo.section; // 팀명
        case 6:
          return func.getContent(value).stdInfo.writer_name; // 작성자
        case 7:
          return func.getCreatedDate(value.created_at); // 작성일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
